import { FetchMethod, useCodeerApi } from "../useCodeerApi"
import { Response, ProviderConfig } from "@/types"
import {
  ConnectionSchema,
  ProviderConfigSchema,
  providerConfigToProviderConfigSchema,
} from "./types"

export interface ConnectionResponse extends ConnectionSchema {}

export interface CreateConnectionRequest {
  name: string
  provider: string
  provider_config?: ProviderConfigSchema
}

export const makeCreateConnectionRequest = (
  name: string,
  provider: string,
  providerConfig?: ProviderConfig
): CreateConnectionRequest => {
  return {
    name,
    provider,
    provider_config: providerConfigToProviderConfigSchema(providerConfig),
  }
}

export { transToConnection as connectionResponseToConnection } from "./types"

export const useGetConnectionsApi = () => {
  return useCodeerApi<Response<ConnectionResponse[]>>(
    "/connections",
    FetchMethod.Get
  )
}

export const useGetConnectionByIdApi = () => {
  return useCodeerApi<Response<ConnectionResponse>>(
    "/connections/__placeholder__",
    FetchMethod.Get,
    true,
    (params) => `/connections/${String(params.connectionId)}`
  )
}

export const useCreateConnectionApi = () => {
  return useCodeerApi<Response<ConnectionResponse>, CreateConnectionRequest>(
    "/connections",
    FetchMethod.Post
  )
}

export const useDeleteConnectionApi = (id: string) => {
  return useCodeerApi<Response<unknown>>(
    `/connections/${id}`,
    FetchMethod.Delete
  )
}

export interface GoogleDrivePickerTokenResponse {
  token: string
  expires_at?: string | null
}

export const useGetGoogleDrivePickerTokenByConnectionIdApi = () => {
  return useCodeerApi<Response<GoogleDrivePickerTokenResponse>>(
    "/connections/__placeholder__/google-drive/picker-token",
    FetchMethod.Post,
    true,
    (params) =>
      `/connections/${String(params.connection_id)}/google-drive/picker-token`
  )
}
